<template>
    <div class="bluevalue-box">
        <h3 class="caption">{{bluevalueData.caption}}</h3>
        <p class="title">{{bluevalueData.title}}</p>
        <div class="center-box">
            <div class="item-box" v-for='(item,index) in bluevalueData.itemData' :kye='index'>
                <div class="imgbox" :style="{backgroundImage:'url('+item.imgurl+')'}"></div>
                <h5 class="item-caption"><span class="number">{{'0'+(index+1)}}</span>{{item.caption}}</h5>
                <p class="item-center" v-html='item.center'></p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'BlueValue',
        data() {
            return {
                bluevalueData: {
                    caption: '我们的价值观 ...',
                    title: '我们相信，无论公司发展到哪个阶段，共同价值观是我们保持一致的企业文化和凝聚力所在。当个人的价值观和公司的价值观越来越吻合，在日常工作中就更容易把问题变成事情，把事情变为热情，把热情转化为创造力。蓝鲸的六个价值观，在我们如何经营业务、对客服务、招揽人才、考核员工以及决定员工晋升、报酬等扮演着重要的角色。',
                    itemData: [
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/about/8667b5ff-d48a-4460-a68c-1bbce5497c11.jpg',
                            caption: '用心协助企业成长',
                            center: '要做就做最好的！<br/>我们投入百分之百的精力帮助客户在事业上成长的更快、更高效。'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/about/_DSC0409.jpg',
                            caption: '正面积极乐观的沟通',
                            center: '我们相信，正向沟通可以让互动更顺利，不管面对我们的同事、还是客户，都要把自己最好的一面都展现出来。'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/about/_DSC0349.jpg',
                            caption: '迎接每一个改变',
                            center: '对于蓝鲸而言，唯一不变的，就是改变，我们随时准备好一起迎接市场上任何挑战。'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/about/_DSC0481.jpg',
                            caption: '鼓励、分享，创新、培养',
                            center: '我们热衷于分享最好的信息给周围的人，我们也只提供最好的。'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/about/_DSC0282.jpg',
                            caption: '用最快的时间，做出最完美的成效',
                            center: '我们非常理解各位的时间、金钱、资源都很重要，在您还没开口前，我们就可以把所有东西都处理好！'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/about/c3859c99f959800bf25e15476e4c506122.jpg',
                            caption: '只做跟别人不一样的东西',
                            center: '我们持续研究、学习、成长，找到最好的方法，从数字营销领域中脱颖而出。'
                        }
                    ]
                }
            }
        }
    }
</script>
<style scoped>
    .bluevalue-box {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 150px 0 200px 0;
    }

    .caption {
        font-size: 40px;
        font-weight: bold;
        line-height: 56px;
        color: rgba(28, 28, 28, 1);
        letter-spacing: 5px;
        max-width: 325px;
        text-align: center;
        margin-bottom: 90px;
    }

    .title {
        font-size: 16px;
        font-weight: 400;
        line-height: 40px;
        color: rgba(153, 153, 153, 1);
        text-align: center;
        max-width: 64%;
        margin-bottom: 101px;
    }

    .center-box {
        width: 79.94%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 4.8%;
        grid-row-gap: 100px;

    }

    .imgbox {
        width: 100%;
        height: 21.35vw;
        margin-bottom: 40px;
        background: #666666 no-repeat;
        background-size: cover;
    }

    .number {
        display: inline-block;
        width: 48px;
        font-size: 40px;
        font-weight: 400;
        color: #ffffff;
        -webkit-text-stroke: 1px rgba(36, 136, 248, 1);
        text-stroke: 1px rgba(36, 136, 248, 1);
        margin-right: 26px;
    }

    .item-caption {
        font-size: 24px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        padding: 0 40px;
    }

    .item-center {
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        color: rgba(153, 153, 153, 1);
        padding: 0 114px;
    }

    @media(max-width: 995px) {
        .bluevalue-box {
            padding: 15% 0;
        }

        .caption {
            font-size: 24px;
            line-height: 140%;
            letter-spacing: 5px;
            max-width: 45%;
            text-align: center;
            margin-bottom: 5%;
        }

        .title {
            font-size: 16px;
            line-height: 250%;
            max-width: 100%;
            margin-bottom: 5%;
            padding: 0 5%;
        }
        .center-box {
            width: 100%;
            grid-template-columns: 1fr;
            grid-row-gap: 20px;
            padding: 5%;

        }
        .imgbox {
            height: 60vw;
            margin-bottom: 10px;
        }
        .number {
            display: inline-block;
            width: 20px;
            font-size: 20px;
            font-weight: 400;
            padding-right: 5%;
        }
        .item-caption {
            font-size: 18px;
            font-weight: bold;
            line-height: 150%;
            color: rgba(51, 51, 51, 1);
            display: flex;
            align-items: flex-start;
            margin-bottom: 0px;
            padding: 0 0;
        }
        .item-center {
            font-size: 16px;
            font-weight: 400;
            line-height: 200%;
            color: rgba(153, 153, 153, 1);
            padding: 0;
        }

        /* .item-caption {
            font-size: 75px;
            font-weight: bold;
            line-height: 150%;
            color: rgba(51, 51, 51, 1);
            display: flex;
            align-items: flex-start;
            margin-bottom: 15px;
            padding: 0 0;
        }

        .item-center {
            font-size: 50px;
            font-weight: 400;
            line-height: 200%;
            color: rgba(153, 153, 153, 1);
            padding: 0;
        }

        .center-box {
            width: 100%;
            padding: 0 5%;

        } */
    }

    /* @media(max-width: 1023px) {
        .center-box {
            width: 100%;
            grid-template-columns: 1fr;

        }

        .imgbox {
            height: 1010px;
            margin-bottom: 40px;
        }

        .caption {
            font-size: 75px;
            line-height: 140%;
            max-width: 28%;
        }

        .title {
            font-size: 50px;
            line-height: 250%;
            max-width: 100%;
            padding: 0 5%;
        }

        .number {
            display: inline-block;
            width: 48px;
            font-size: 78px;
            font-weight: 400;
            padding-right: 5%;
        }

        .item-caption {
            font-size: 75px;
            font-weight: bold;
            line-height: 150%;
            color: rgba(51, 51, 51, 1);
            display: flex;
            align-items: flex-start;
            margin-bottom: 15px;
            padding: 0 0;
        }

        .item-center {
            font-size: 50px;
            font-weight: 400;
            line-height: 200%;
            color: rgba(153, 153, 153, 1);
            padding: 0;
        }

        .center-box {
            width: 100%;
            padding: 0 5%;

        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/about/bluevalue.vue